import { render, staticRenderFns } from "./HyphenTextarea.vue?vue&type=template&id=744b69e0&scoped=true"
import script from "./HyphenTextarea.vue?vue&type=script&setup=true&lang=js"
export * from "./HyphenTextarea.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HyphenTextarea.vue?vue&type=style&index=0&id=744b69e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744b69e0",
  null
  
)

export default component.exports